import {
  getAddress1,
  getAddress2,
  getBranch,
  getFirstName,
  getKey,
  getLastName,
  getToken,
  getUser,
  getUserName,
  getUserType,
} from "../Utils/Common"
import {
  getAPICall,
  postAPICall,
  putAPICall,
  deleteAPICall,
  API_KEY,
  TOKEN,
  postAPICall2,
  getAPICallGoogle,
} from "./axiosMethodCalls"

// Check if we're in development mode and should use mock authentication
const USE_MOCK_AUTH = process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_MOCK_AUTH === 'true';

//Add Information API
export const createInfo = async (primaryDetails) => {
  // Use mock response if enabled
  if (USE_MOCK_AUTH) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            success: true,
            message: "Form submitted successfully",
            form_id: Math.floor(Math.random() * 1000) + 1,
            timestamp: new Date().toISOString()
          }
        });
      }, 1500); // Simulate network delay
    });
  }

  // Original API call for production
  var full_name = getFirstName() + " " + getLastName()
  try {
    var formData = new FormData()

    if (primaryDetails.merchant_id !== "Others") {
      formData.append("merchant_id", primaryDetails.merchant_id)
    }
    if (primaryDetails.outlet_id !== "Others") {
      formData.append("outlet_id", primaryDetails.outlet_id)
    }
    formData.append("requester", getUser())
    formData.append("token", getToken().replace(/['"]+/g, ""))
    formData.append("full_name", full_name)
    formData.append("merchant_name", primaryDetails.merchant_name)

    formData.append("outlet", primaryDetails.outlet)
    formData.append("city", primaryDetails.city)
    formData.append("brgy", primaryDetails.brgy)
    formData.append("postal_code", primaryDetails.postal_code)
    formData.append("floor_no", primaryDetails.floor_no)
    formData.append("building", primaryDetails.building)
    formData.append("coordinates", primaryDetails.coordinates)
    formData.append("is_maya_merchant", primaryDetails.maya_merchant)
    formData.append("maya_merchant_sqr", primaryDetails.merchant_mid_sqr)
    formData.append(
      "maya_merchant_terminal",
      primaryDetails.merchant_mid_terminal
    )
    formData.append("terminal_sn", primaryDetails.sn_terminal)
    formData.append("sqr_store_code", primaryDetails.store_code)
    formData.append("name", primaryDetails.name)
    formData.append("number", primaryDetails.number)
    formData.append("email", primaryDetails.email)
    formData.append("qrph_awareness", primaryDetails.qrph_known)
    formData.append("maya_solutions", primaryDetails.maya_solutions)
    formData.append(
      "merchandising_restrictions",
      primaryDetails.merchandising_restrictions
    )
    formData.append("retraining_concern", primaryDetails.retraining_concern)
    formData.append("is_resolved", primaryDetails.is_resolved)
    formData.append("escalation", primaryDetails.escalation)
    formData.append("available_terminal", primaryDetails.available_terminal)
    formData.append("solution_device", primaryDetails.solution_device)
    formData.append("maya_transaction", primaryDetails.maya_transaction)
    formData.append("gcash_transaction", primaryDetails.gcash_transaction)
    formData.append("cash_transaction", primaryDetails.cash_transaction)
    formData.append(
      "other_transaction_details",
      primaryDetails.other_transaction_details
    )
    formData.append("other_transaction", primaryDetails.other_transaction)
    formData.append("own_merchandising", primaryDetails.own_merchandising)
    formData.append("merchant_concern", primaryDetails.merchant_concern)
    formData.append("servicing", primaryDetails.servicing)
    formData.append("replacement", primaryDetails.replacement)
    formData.append(
      "merchandising_request",
      primaryDetails.merchandising_request
    )
    formData.append(
      "available_terminal_other_details",
      primaryDetails.available_terminal_other_details
    )
    formData.append(
      "solution_device_other_details",
      primaryDetails.solution_device_other_details
    )
    formData.append(
      "own_merchandising_other_details",
      primaryDetails.own_merchandising_other_details
    )
    formData.append(
      "merchant_concern_other_details",
      primaryDetails.merchant_concern_other_details
    )
    formData.append(
      "servicing_other_details",
      primaryDetails.servicing_other_details
    )
    formData.append(
      "merchandising_request_other_details",
      primaryDetails.merchandising_request_other_details
    )

    // for (const [key, value] of Object.entries(primaryDetails)) {
    //   if (key === "serial_numbers") {
    //     const serial = value.join(", ");
    //     formData.append("device_serial_numbers", serial);
    //   } else if (key === "store_codes") {
    //     const codes = value.join(", ");
    //     formData.append("sqr_store_codes", codes);
    //   } else if(key === "other_competitor"){
    //     // console.log(value)
    //     Array.from(value).forEach(file => {
    //       formData.append('other_competitor[]', file);
    //     })
    //   } else {
    //     formData.append(key, value);
    //   }
    // }

    const response = await postAPICall2(
      process.env.REACT_APP_LINK + "example/add",
      formData
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getByProcastCode = async (procastCode) => {
  console.log("Calling getByProcastCode with:", procastCode);
  try {
    const formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken().replace(/['"]+/g, ""));
    formData.append("procast_code", procastCode);
    
    const response = await postAPICall2(
      process.env.REACT_APP_LINK + "forms/get_by_procast_code",
      formData
    );
    console.log("API Response:", response);
    return { data: response.data };
  } catch (error) {
    console.error("API Error:", error);
    return { error: error.response };
  }
}

export const submitForm = async (partialDetails, regionConfig) => {
  try {
    const formData = new FormData();
    const mallTypeField = regionConfig?.formFields?.mall_type;
    const mallTypeValue = mallTypeField ? partialDetails[mallTypeField] : null;
    formData.append("requester", getUser());
    formData.append("token", getToken().replace(/['"]+/g, ""));

    const existingId = (partialDetails?._partial_saved === true && partialDetails?.id)
      ? partialDetails.id
      : null;

    // --- Section 1, Page 1 ---
    if (partialDetails.tas) formData.append("tas", partialDetails.tas);
    if (partialDetails.activity_name) formData.append("activity_name", partialDetails.activity_name);
    if (partialDetails.visit_date) formData.append("visit_date", partialDetails.visit_date);
    if (partialDetails.visit_time) formData.append("visit_time", partialDetails.visit_time);

    // --- Page 2 ---
    if (partialDetails.procast_code) formData.append("procast_code", partialDetails.procast_code);
    if (partialDetails.company_name) formData.append("company_name", partialDetails.company_name);
    if (partialDetails.store_name) formData.append("store_name", partialDetails.store_name);
    if (partialDetails.trade_name) formData.append("trade_name", partialDetails.trade_name);

    // --- Page 3 ---
    if (partialDetails.region) formData.append("region", partialDetails.region);
    const provinceField = regionConfig?.formFields?.province;
    const municipalityField = regionConfig?.formFields?.municipality;
    if (provinceField && partialDetails[provinceField]) {
      formData.append("province", partialDetails[provinceField]);
    }
    if (municipalityField && partialDetails[municipalityField]) {
      formData.append("municipality", partialDetails[municipalityField]);
    }
    // THESE IS THE FIX FOR THE MALL NAME AUTOFILL
    if (mallTypeValue) formData.append("mall_type", mallTypeValue);
    if (mallTypeValue === "Mall (single or multiple buildings)" || mallTypeValue === "Non-Mall (located in a compound/grouped with other merchants)") {
      // --Page 4 -- fallback sa generic mall_name kung wala sa region-specific key
      const mallNameField = regionConfig?.formFields?.mall_name;
      const mallNameValue = (mallNameField && partialDetails[mallNameField]) || partialDetails.mall_name;
      if (mallNameValue) {
        formData.append("mall_name", mallNameValue);
      }
      // -- Page 5 --
      if (partialDetails.floor_no) formData.append("floor_no", partialDetails.floor_no);
    }
    // if (mallTypeValue) formData.append("mall_type", mallTypeValue);
    // if (mallTypeValue === "Mall (single or multiple buildings)" || mallTypeValue === "Non-Mall (located in a compound/grouped with other merchants)") {
    //   // --Page 4 --
    //   if (regionConfig?.formFields?.mall_name && partialDetails[regionConfig.formFields.mall_name]) {
    //     formData.append("mall_name", partialDetails[regionConfig.formFields.mall_name]);
    //   }
    //   // -- Page 5 --
    //   if (partialDetails.floor_no) formData.append("floor_no", partialDetails.floor_no);
    // }
    // -- Page 6 --
    if (partialDetails.address) formData.append("address", partialDetails.address);
    if (partialDetails.landmark) formData.append("landmark", partialDetails.landmark);
    if (partialDetails.coordinates) formData.append("coordinates", partialDetails.coordinates);
    if (partialDetails.google_map) formData.append("google_map", partialDetails.google_map);
    if (partialDetails.link_type) formData.append("link_type", partialDetails.link_type);

    // --- Page 7 INDUSTRY & TYPE OF STORE ---
    if (partialDetails.industry) formData.append("industry", partialDetails.industry);
    if (partialDetails.store_type) formData.append("store_type", partialDetails.store_type);

    // --- Page 8 CANENGAGE.jsx ---
    if (partialDetails.engagement) formData.append("engagement", partialDetails.engagement);

    // page 9
    if (partialDetails.engagement_remarks) {
      formData.append("engagement_remarks", partialDetails.engagement_remarks);
    }
    // TYPE OF MERCHANT.jsx
    if (partialDetails.merchant_type) {
      formData.append("merchant_type", partialDetails.merchant_type);
    }
    // From MayaSolution.jsx  -- Section 14 --
    if (partialDetails.maya_solution) {
      formData.append("maya_solution", partialDetails.maya_solution);
    }
    // From InterestedMayaSolution.jsx
    if (partialDetails.is_interested) {
      formData.append("is_interested", partialDetails.is_interested);
    }
    // From NotInterestedMayaSolution.jsx
    if (partialDetails.not_interested_reason) {
      formData.append("not_interested_reason", partialDetails.not_interested_reason);
    }
    if (partialDetails.pending_application) {
      formData.append("pending_application", partialDetails.pending_application);
    }
    if (partialDetails.pending_solution) {
      formData.append("pending_solution", partialDetails.pending_solution);
    }
     // From MayaTerminalSolutionDetails.jsx (may be stored in primaryDetails or a sibling object)
    if (partialDetails.terminal_available) {
      formData.append("terminal_available", partialDetails.terminal_available);
    }
    if (partialDetails.poa) {
      formData.append("poa", partialDetails.poa);
    }


    // Overall terminal stickering (single field for all terminals)
    if (partialDetails.is_stickered) {
      formData.append("is_stickered", partialDetails.is_stickered);
    }
    
    // From TerminalStickering.jsx
    if (partialDetails.no_stickered_reason) {
      formData.append("no_stickered_reason", partialDetails.no_stickered_reason);
    }
    if (partialDetails.num_stickered_detail) {
      formData.append("num_stickered_detail", partialDetails.num_stickered_detail);
    }

    //     // From ThermalRoll.jsx
    if (partialDetails.thermal_roll_stock) {
      formData.append("thermal_roll_stock", partialDetails.thermal_roll_stock);
    }
    if (partialDetails.thermal_roll_delivery) {
      formData.append("thermal_roll_delivery", partialDetails.thermal_roll_delivery);
    }

    // From TerminalStickeringDetails.jsx
    if (partialDetails.no_of_stickered) {
      formData.append("no_of_stickered", partialDetails.no_of_stickered);
    }
    if (partialDetails.is_sticker_wasted) {
      formData.append("is_sticker_wasted", partialDetails.is_sticker_wasted);
    }
    if (partialDetails.p1_front_before_photo_temp_path) {
      formData.append("temp_p1_front_before_photo", partialDetails.p1_front_before_photo_temp_path);
    }
    if (partialDetails.p1_back_before_photo_temp_path) {
      formData.append("temp_p1_back_before_photo", partialDetails.p1_back_before_photo_temp_path);
    }
    if (partialDetails.p1_front_after_photo_temp_path) {
      formData.append("temp_p1_front_after_photo", partialDetails.p1_front_after_photo_temp_path);
    }
    if (partialDetails.p1_back_after_photo_temp_path) {
      formData.append("temp_p1_back_after_photo", partialDetails.p1_back_after_photo_temp_path);
    }

// From WastedTerminalSticker.jsx
if (partialDetails.sticker_wasted_count) {
  formData.append("sticker_wasted_count", partialDetails.sticker_wasted_count);
}
if (partialDetails.sticker_wasted_reason) {
  formData.append("sticker_wasted_reason", partialDetails.sticker_wasted_reason);
}
if (partialDetails.wasted_photo_temp_path) {
  formData.append("temp_wasted_photo", partialDetails.wasted_photo_temp_path);
}

// From ThermalRollDeliveryPage.jsx
if (partialDetails.thermal_roll_no) {
  formData.append("thermal_roll_no", partialDetails.thermal_roll_no);
}
if (partialDetails.thermal_roll_photo_temp_path) {
  formData.append("temp_thermal_roll_photo", partialDetails.thermal_roll_photo_temp_path);
}
if (partialDetails.thermal_roll_delivery_receipt_temp_path) {
  formData.append("temp_thermal_roll_delivery_receipt", partialDetails.thermal_roll_delivery_receipt_temp_path);
}

// ThermalRollDeliveryYesPage
if (partialDetails.thermal_roll_escalation_photo_temp_path) {
  formData.append("temp_thermal_roll_escalation_photo", partialDetails.thermal_roll_escalation_photo_temp_path);
}

// From ChargerDelivery.jsx
if (partialDetails.charger_delivery) {
  formData.append("charger_delivery", partialDetails.charger_delivery);
}

// From ChargerDeliveryYesPage.jsx
if (partialDetails.charger_case_no) {
  formData.append("charger_case_no", partialDetails.charger_case_no);
}
if (partialDetails.charger_request_photo_temp_path) {
  formData.append("temp_charger_request_photo", partialDetails.charger_request_photo_temp_path);
}
if (partialDetails.charger_delivery_receipt_temp_path) {
  formData.append("temp_charger_delivery_receipt", partialDetails.charger_delivery_receipt_temp_path);
}

// WorkingTerminalDetails — temp paths per terminal
if (partialDetails.working_terminals && Array.isArray(partialDetails.working_terminals)) {
  formData.append("working_terminals", JSON.stringify(partialDetails.working_terminals));

  if (partialDetails.working_terminals.length > 0) {
    const terminalModels = [];
    const serialNumbers = [];
    const terminalIds = [];
    const cardEfs = [];
    const qrEfs = [];
    const notObtainingMidReasons = [];
    const otherReasonNoMids = [];
    const batteryCharges = [];
    const isDefectives = [];

    partialDetails.working_terminals.forEach((terminal, index) => {
      if (terminal.terminal_type) {
        const types = Array.isArray(terminal.terminal_type)
          ? terminal.terminal_type.join(', ')
          : terminal.terminal_type;
        terminalModels.push(types);
      }
      if (terminal.serial_number) serialNumbers.push(terminal.serial_number);
      if (terminal.terminal_id) terminalIds.push(terminal.terminal_id);
      if (terminal.card_efs) cardEfs.push(terminal.card_efs);
      if (terminal.merchant_id) qrEfs.push(terminal.merchant_id);
      if (terminal.not_obtaining_mid_reason) notObtainingMidReasons.push(terminal.not_obtaining_mid_reason);
      if (terminal.other_reason_no_mid) otherReasonNoMids.push(terminal.other_reason_no_mid);
      if (terminal.battery_charge) batteryCharges.push(terminal.battery_charge);
      if (terminal.is_defective) isDefectives.push(terminal.is_defective);

      // Send temp paths per terminal
      if (terminal.receipt_photo_temp_path) {
        formData.append(`temp_receipt_photo_${index}`, terminal.receipt_photo_temp_path);
      }
      if (terminal.terminal_front_photo_temp_path) {
        formData.append(`temp_terminal_front_photo_${index}`, terminal.terminal_front_photo_temp_path);
      }
      if (terminal.terminal_back_photo_temp_path) {
        formData.append(`temp_terminal_back_photo_${index}`, terminal.terminal_back_photo_temp_path);
      }
    });

    if (terminalModels.length > 0) formData.append("terminal_model", terminalModels.join(', '));
    if (serialNumbers.length > 0) formData.append("serial_number", serialNumbers.join(', '));
    if (terminalIds.length > 0) formData.append("terminal_id", terminalIds.join(', '));
    if (cardEfs.length > 0) formData.append("card_efs", cardEfs.join(', '));
    if (qrEfs.length > 0) formData.append("qr_efs", qrEfs.join(', '));
    if (notObtainingMidReasons.length > 0) formData.append("not_obtaining_mid_reason", notObtainingMidReasons.join(', '));
    if (otherReasonNoMids.length > 0) formData.append("other_reason_no_mid", otherReasonNoMids.join(', '));
    if (batteryCharges.length > 0) formData.append("battery_charge", batteryCharges.join(', '));
    if (isDefectives.length > 0) formData.append("is_defective", isDefectives.join(', '));
  }
}

// MayaSQRSolutionDetails — temp paths per sqr item
if (partialDetails.sqr_items && Array.isArray(partialDetails.sqr_items)) {
  formData.append("sqr_items", JSON.stringify(partialDetails.sqr_items));

  if (partialDetails.sqr_items.length > 0) {
    const sqrStoreCodes = [];
    const sqrStorCodeReasons = [];
    const sqrStoreCodeReasonTexts = [];
    const sqrConcerns = [];
    const sqrStandeeLocations = [];
    const sqrCounts = [];
    const sqrUpdateds = [];
    const sqrBrands = [];
    const sqrUnupdatedReasons = [];

    partialDetails.sqr_items.forEach((sqr, index) => {
      if (sqr.sqr_store_code) sqrStoreCodes.push(sqr.sqr_store_code);
      if (sqr.sqr_store_code_unobtaining_reason) sqrStorCodeReasons.push(sqr.sqr_store_code_unobtaining_reason);
      if (sqr.sqr_store_code_unobtaining_reason_text) sqrStoreCodeReasonTexts.push(sqr.sqr_store_code_unobtaining_reason_text);
      if (sqr.has_sqr_concern) sqrConcerns.push(sqr.has_sqr_concern);
      if (sqr.sqr_standee_location) sqrStandeeLocations.push(sqr.sqr_standee_location);
      if (sqr.sqr_count) sqrCounts.push(sqr.sqr_count);
      if (sqr.sqr_updated) sqrUpdateds.push(sqr.sqr_updated);
      if (sqr.sqr_brand) sqrBrands.push(sqr.sqr_brand);
      if (sqr.sqr_unupdated_reason) sqrUnupdatedReasons.push(sqr.sqr_unupdated_reason);

      // Send temp path per sqr item
      if (sqr.sqr_photo_temp_path) {
        formData.append(`temp_sqr_photo_${index}`, sqr.sqr_photo_temp_path);
      }
    });

    if (sqrStoreCodes.length > 0) formData.append("sqr_store_code", sqrStoreCodes.join(', '));
    if (sqrStorCodeReasons.length > 0) formData.append("sqr_store_code_unobtaining_reason", sqrStorCodeReasons.join(', '));
    if (sqrStoreCodeReasonTexts.length > 0) formData.append("sqr_store_code_unobtaining_reason_text", sqrStoreCodeReasonTexts.join(', '));
    if (sqrConcerns.length > 0) formData.append("has_sqr_concern", sqrConcerns.join(', '));
    if (sqrStandeeLocations.length > 0) formData.append("sqr_standee_location", sqrStandeeLocations.join(', '));
    if (sqrCounts.length > 0) formData.append("sqr_count", sqrCounts.join(', '));
    if (sqrUpdateds.length > 0) formData.append("sqr_updated", sqrUpdateds.join(', '));
    if (sqrBrands.length > 0) formData.append("sqr_brand", sqrBrands.join(', '));
    if (sqrUnupdatedReasons.length > 0) formData.append("sqr_unupdated_reason", sqrUnupdatedReasons.join(', '));
    formData.append('sqr_items_count', partialDetails.sqr_items.length);
  }
}

    // Merchandising — temp paths per item
    if (partialDetails.merchandising_items && Array.isArray(partialDetails.merchandising_items)) {
      const merchandisingTypes = [];
      const merchandisingBrandings = [];
      const merchandisingLocations = [];

      partialDetails.merchandising_items.forEach((item, index) => {
        if (item.merchandising_type) merchandisingTypes.push(item.merchandising_type);
        if (item.merchandising_branding) merchandisingBrandings.push(item.merchandising_branding);
        if (item.merchandising_location) merchandisingLocations.push(item.merchandising_location);

        // Send temp path per merchandising item
        if (item.merchandising_photo_temp_path) {
          formData.append(`temp_merchandising_photo_${index}`, item.merchandising_photo_temp_path);
        }
      });

      if (merchandisingTypes.length > 0) formData.append("merchandising_type", merchandisingTypes.join(', '));
      if (merchandisingBrandings.length > 0) formData.append("merchandising_branding", merchandisingBrandings.join(', '));
      if (merchandisingLocations.length > 0) formData.append("merchandising_location", merchandisingLocations.join(', '));
      formData.append('merchandising_items_count', partialDetails.merchandising_items.length);
    }

    // Maya Black — always send regardless of merchandising_items
    if (partialDetails.maya_black_merchandising_type) {
      formData.append("maya_black_merchandising_type", partialDetails.maya_black_merchandising_type);
    }
    if (partialDetails.maya_black_merchandising_branding) {
      formData.append("maya_black_merchandising_branding", partialDetails.maya_black_merchandising_branding);
    }
    if (partialDetails.location) {
      formData.append("location", partialDetails.location);
    }

  // Maya Black
  // if (partialDetails.maya_black_merchandising_type) {
  //   formData.append("maya_black_merchandising_type", partialDetails.maya_black_merchandising_type);
  // }
  // if (partialDetails.maya_black_merchandising_branding) {
  //   formData.append("maya_black_merchandising_branding", partialDetails.maya_black_merchandising_branding);
  // }

    // VisibilityPhoto
    if (partialDetails.counter_top_photo_temp_path) {
      formData.append("temp_counter_top_photo", partialDetails.counter_top_photo_temp_path);
    }
    if (partialDetails.store_type_photo_temp_path) {
      formData.append("temp_store_type_photo", partialDetails.store_type_photo_temp_path);
    }

    // Remarks
    if (partialDetails.store_photo_temp_path) {
      formData.append("temp_store_photo", partialDetails.store_photo_temp_path);
    }

    // CompetitorPromoConsumers
    if (partialDetails.consumer_promo_photo_temp_path) {
      formData.append("temp_consumer_promo_photo", partialDetails.consumer_promo_photo_temp_path);
    }

    // CompetitorPromoMerchant
    if (partialDetails.merchant_promo_photo_temp_path) {
      formData.append("temp_merchant_promo_photo", partialDetails.merchant_promo_photo_temp_path);
    }

    // CompetitorPriority
    if (partialDetails.promo_merch_mats_temp_path) {
      formData.append("temp_promo_merch_mats", partialDetails.promo_merch_mats_temp_path);
    }
    if (partialDetails.store_front_photo_temp_path) {
      formData.append("temp_store_front_photo", partialDetails.store_front_photo_temp_path);
    }

    // NonMayaMerchantInfo
    if (partialDetails.registration_photo_temp_path) {
      formData.append("temp_registration_photo", partialDetails.registration_photo_temp_path);
    }

    // MayaAccountDetails
    if (partialDetails.maya_account_photo_temp_path) {
      formData.append("temp_maya_account_photo", partialDetails.maya_account_photo_temp_path);
    }

    // JoiningMayaMallProgramSection72
    if (partialDetails.acknowledgement_receipt_temp_path) {
      formData.append("temp_acknowledgement_receipt", partialDetails.acknowledgement_receipt_temp_path);
    }

    // AwardingMerienda
    if (partialDetails.merienda_purchase_receipt_temp_path) {
      formData.append("temp_merienda_purchase_receipt", partialDetails.merienda_purchase_receipt_temp_path);
    }
    if (partialDetails.merienda_certificate_temp_path) {
      formData.append("temp_merienda_certificate", partialDetails.merienda_certificate_temp_path);
    }

    // AwardingFlagship
    if (partialDetails.flagship_freebies_temp_path) {
      formData.append("temp_flagship_freebies", partialDetails.flagship_freebies_temp_path);
    }

    // AwardingMayaCredit
    if (partialDetails.verified_maya_account_photo_temp_path) {
      formData.append("temp_verified_maya_account_photo", partialDetails.verified_maya_account_photo_temp_path);
    }

    // AwardingDetails
    if (partialDetails.received_maya_credit_photo_temp_path) {
      formData.append("temp_received_maya_credit_photo", partialDetails.received_maya_credit_photo_temp_path);
    }
    if (partialDetails.maya_account_name_photo) {
      formData.append("maya_account_name_photo", partialDetails.maya_account_name_photo);
    }
    if (partialDetails.maya_account_number_photo) {
      formData.append("maya_account_number_photo", partialDetails.maya_account_number_photo);
    }
    if (partialDetails.amount_transferred) {
      formData.append("amount_transferred", partialDetails.amount_transferred);
    }
    if (partialDetails.reference_no) {
      formData.append("reference_no", partialDetails.reference_no);
    }
    if (partialDetails.maya_account_position_photo) {
      formData.append("maya_account_position_photo", partialDetails.maya_account_position_photo);
    }
    // // From NonMayaMerchantInfo.jsx - text fields
    // if (partialDetails.maya_account_name) {
    //   formData.append("maya_account_name", partialDetails.maya_account_name);
    // }
    // if (partialDetails.maya_account_number) {
    //   formData.append("maya_account_number", partialDetails.maya_account_number);
    // }
    // if (partialDetails.maya_account_position) {
    //   formData.append("maya_account_position", partialDetails.maya_account_position);
    // }
    // From NonMayaMerchantInfo.jsx
    if (partialDetails.non_maya_merchant_type) {
      formData.append("non_maya_merchant_type", partialDetails.non_maya_merchant_type);
    }
    if (partialDetails.registration_type) {
      formData.append("registration_type", partialDetails.registration_type);
    }
    
    if (partialDetails.credit_certificate_temp_path) {
      formData.append("temp_credit_certificate", partialDetails.credit_certificate_temp_path);
    }
    // if (partialDetails.amount_transferred_temp_path) {
    //   formData.append("temp_amount_transferred", partialDetails.amount_transferred_temp_path);
    // }
    // if (partialDetails.reference_no_temp_path) {
    //   formData.append("temp_reference_no", partialDetails.reference_no_temp_path);
    // }
    if (partialDetails.upload_company_id_temp_path) {
      formData.append("temp_upload_company_id", partialDetails.upload_company_id_temp_path);
    }

    // SQRPhoto standalone
    if (partialDetails.sqr_photo_temp_path) {
      formData.append("temp_sqr_photo", partialDetails.sqr_photo_temp_path);
    }

    // InstalledP1DoorSticker
    if (partialDetails.installed_p1_door_sticker_photo_temp_path) {
      formData.append("temp_installed_p1_door_sticker_photo", partialDetails.installed_p1_door_sticker_photo_temp_path);
    }

    // InstalledQRPHDoorSticker
    if (partialDetails.qrph_door_sticker_installed_photo_temp_path) {
      formData.append("temp_qrph_door_sticker_installed_photo", partialDetails.qrph_door_sticker_installed_photo_temp_path);
    }

    // DCCFlyerPhoto
    if (partialDetails.dcc_photo_temp_path) {
      formData.append("temp_dcc_photo", partialDetails.dcc_photo_temp_path);
    }

    // TroubleshootQRStickerPhoto
    if (partialDetails.qr_sticker_distribution_photo_temp_path) {
      formData.append("temp_qr_sticker_distribution_photo", partialDetails.qr_sticker_distribution_photo_temp_path);
    }

    // TroubleshootP1StickerPhoto
    if (partialDetails.p1_sticker_photo_temp_path) {
      formData.append("temp_p1_sticker_photo", partialDetails.p1_sticker_photo_temp_path);
    }

    // MayaKitaClubFlyerPhoto
    if (partialDetails.flyer_distribution_photo_temp_path) {
      formData.append("temp_flyer_distribution_photo", partialDetails.flyer_distribution_photo_temp_path);
    }

    // photo_2303
    if (partialDetails.photo_2303_temp_path) {
      formData.append("temp_photo_2303", partialDetails.photo_2303_temp_path);
    }
    if (partialDetails.ems) {
      formData.append("ems", partialDetails.ems);
    }

    // From TerminalAvailability.jsx — align with backend fields
    if (partialDetails.available_terminal) {
      const availableTerminal = Array.isArray(partialDetails.available_terminal)
        ? JSON.stringify(partialDetails.available_terminal)
        : partialDetails.available_terminal;
      formData.append("available_terminal", availableTerminal);
    }
     if (partialDetails.other_available_terminal) {
      formData.append("other_available_terminal", partialDetails.other_available_terminal);
    }
    // Map "Others" free-text strictly to backend `other_available_terminal`
    if (partialDetails.any_other_available_terminal) {
      formData.append("any_other_available_terminal", partialDetails.any_other_available_terminal);
    }

    // From SQRAvailability.jsx — align with backend fields
    if (partialDetails.qr_provider) {
      const availableQr = Array.isArray(partialDetails.qr_provider)
        ? JSON.stringify(partialDetails.qr_provider)
        : partialDetails.qr_provider;
      formData.append("qr_provider", availableQr);
    }
    if (partialDetails.any_other_qr_provider) {
      formData.append("any_other_qr_provider", partialDetails.any_other_qr_provider);
    }
    if (partialDetails.other_qr_provider) {
      formData.append("other_qr_provider", partialDetails.other_qr_provider);
    }

    // From CompetitorMerch.jsx — align with backend fields
    if (partialDetails.suppression) {
      // Note: backend expects the key spelled as 'supperssion'
      formData.append("suppression", partialDetails.suppression);
    }

    // Build competitor_merch_id as an object of selections excluding 'none'
    const merchFields = [
      "gcash_sqr_standee",
      "gcash_door_hanger",
      "shopee_sqr_standee",
      "shopee_door_hanger",
      "bdo_sqr_standee",
      "bdo_door_hanger",
      "atome_sqr_standee",
      "atome_door_hanger",
      "metrobank_door_hanger",
    ];
    const competitorMerch = {};
    merchFields.forEach((field) => {
      const val = partialDetails[field];
      if (val && val !== "none") competitorMerch[field] = val; // values: generic_qrph | qr_standee
    });
    if (Object.keys(competitorMerch).length > 0) {
      formData.append("competitor", JSON.stringify(competitorMerch));
    }
    // promotional_standee: collect brands with "yes"
    const promoFields = [
      { field: "gcash_counterl_standee", label: "GCash Counterl Standee (Generic)" },
      { field: "gcash_promotional_standee_heart", label: "GCash Countertop Standee (w/ Heart Evangelista)" },
      { field: "gcash_heart_life_size_standee", label: "GCash Heart Evangelista Life Size Standee" },
      { field: "shopee_counter_top_standee", label: "Shopee Counter top Standee" },
      { field: "bdo_counter_top_standee", label: "BDO Counter top Standee" },
      { field: "atome_counter_top_standee", label: "Atome Counter top Standee" },
      { field: "metrobank_counter_top_standee", label: "Metrobank Counter top Standee" },
    ];
    const promotionalSelected = promoFields
      .filter(p => partialDetails[p.field] === "yes")
      .map(p => p.label);
    if (promotionalSelected.length > 0) {
      formData.append("promotional_standee", JSON.stringify(promotionalSelected));
    }

    // From CompetitorPromoConsumers.jsx
    if (partialDetails.consumer_promo_title) {
      formData.append("consumer_promo_title", partialDetails.consumer_promo_title);
    }
    if (partialDetails.consumer_promo_acquirer) {
      formData.append("consumer_promo_acquirer", partialDetails.consumer_promo_acquirer);
    }
    if (partialDetails.consumer_promo_mechanics) {
      formData.append("consumer_promo_mechanics", partialDetails.consumer_promo_mechanics);
    }
    if (partialDetails.consumer_promo_duration) {
      formData.append("consumer_promo_duration", partialDetails.consumer_promo_duration);
    }

    // From Merchantothersolutions
    if (partialDetails.is_grab_merchant) {
      formData.append("is_grab_merchant", partialDetails.is_grab_merchant);
    }
    if (partialDetails.is_food_panda_merchant) {
      formData.append("is_food_panda_merchant", partialDetails.is_food_panda_merchant);
    }
    // From CompetitorPromoMerchant.jsx
    if (partialDetails.merchant_promo_title) {
      formData.append("merchant_promo_title", partialDetails.merchant_promo_title);
    }
    if (partialDetails.merchant_promo_acquirer) {
      formData.append("merchant_promo_acquirer", partialDetails.merchant_promo_acquirer);
    }
    if (partialDetails.merchant_promo_mechanics) {
      formData.append("merchant_promo_mechanics", partialDetails.merchant_promo_mechanics);
    }
    if (partialDetails.merchant_promo_duration) {
      formData.append("merchant_promo_duration", partialDetails.merchant_promo_duration);
    }

    // From PointOfContact.jsx
    if (partialDetails.full_name) {
      formData.append("full_name", partialDetails.full_name);
    }
    if (partialDetails.position) {
      formData.append("position", partialDetails.position);
    }
    if (partialDetails.other_position) {
      formData.append("other_position", partialDetails.other_position);
    }
    if (partialDetails.mobile) {
      formData.append("mobile", partialDetails.mobile);
    }
    if (partialDetails.landline) {
      formData.append("landline", partialDetails.landline);
    }
    if (partialDetails.email) {
      formData.append("email", partialDetails.email);
    }
    if (partialDetails.store_hours) {
      formData.append("store_hours", partialDetails.store_hours);
    }
    if (partialDetails.freebies) {
      formData.append("freebies", partialDetails.freebies);
    }

    // From ViberAccount.jsx
    if (partialDetails.viber_account) {
      formData.append("viber_account", partialDetails.viber_account);
    }
    if (partialDetails.viber_account_number) {
      formData.append("viber_account_number", partialDetails.viber_account_number);
    }
    if (partialDetails.viber_account_name) {
      formData.append("viber_account_name", partialDetails.viber_account_name);
    }
    if (partialDetails.viber_community) {
      formData.append("viber_community", partialDetails.viber_community);
    }

    // From HandlingAndMerchantConcerns.jsx
    if (partialDetails.rm_concern) {
      formData.append("rm_concern", JSON.stringify(partialDetails.rm_concern));
    }
    if (partialDetails.merchant_concern) {
      formData.append("merchant_concern", JSON.stringify(partialDetails.merchant_concern));
    }
    if (partialDetails.rm_merchant_other_concern) {
      formData.append("rm_merchant_other_concern", partialDetails.rm_merchant_other_concern);
    }
    if (partialDetails.merchant_transaction) {
      formData.append("merchant_transaction", partialDetails.merchant_transaction);
    }
    if (partialDetails.terminal_concern) {
      formData.append("terminal_concern", partialDetails.terminal_concern);
    }
    if (partialDetails.sqr_concern) {
      formData.append("sqr_concern", partialDetails.sqr_concern);
    }

    // From MayaMerchantSurvey.jsx
    if (partialDetails.maya_terminal_preference) {
      formData.append("maya_terminal_preference", partialDetails.maya_terminal_preference);
    }
    if (partialDetails.prefer_maya_reasons && partialDetails.prefer_maya_reasons.length > 0) {
      formData.append("prefer_maya_reasons", partialDetails.prefer_maya_reasons.join(", "));
    }
    if (partialDetails.prefer_maya_other) {
      formData.append("prefer_maya_other", partialDetails.prefer_maya_other);
    }
    if (partialDetails.preferred_payment_terminal) {
      formData.append("preferred_payment_terminal", partialDetails.preferred_payment_terminal);
    }
    if (partialDetails.preferred_payment_terminal_other) {
      formData.append(
        "preferred_payment_terminal_other",
        partialDetails.preferred_payment_terminal_other
      );
    }
    if (partialDetails.not_prefer_maya_reasons && partialDetails.not_prefer_maya_reasons.length > 0) {
      formData.append(
        "not_prefer_maya_reasons",
        partialDetails.not_prefer_maya_reasons.join(", ")
      );
    }
    if (partialDetails.not_prefer_maya_other) {
      formData.append("not_prefer_maya_other", partialDetails.not_prefer_maya_other);
    }
    if (
      partialDetails.choose_preferred_terminal_reasons &&
      partialDetails.choose_preferred_terminal_reasons.length > 0
    ) {
      formData.append(
        "choose_preferred_terminal_reasons",
        partialDetails.choose_preferred_terminal_reasons.join(",")
      );
    }
    if (partialDetails.choose_preferred_terminal_other) {
      formData.append(
        "choose_preferred_terminal_other",
        partialDetails.choose_preferred_terminal_other
      );
    }
    if (partialDetails.influence_prefer_maya && partialDetails.influence_prefer_maya.length > 0) {
      formData.append(
        "influence_prefer_maya",
        partialDetails.influence_prefer_maya.join(", ")
      );
    }
    if (partialDetails.influence_prefer_maya_other) {
      formData.append("influence_prefer_maya_other", partialDetails.influence_prefer_maya_other);
    }

    // From NonMayaMerchantsSurvey.jsx
    if (partialDetails.non_maya_preferred_terminal) {
      formData.append("non_maya_preferred_terminal", partialDetails.non_maya_preferred_terminal);
    }
    if (partialDetails.non_maya_preferred_terminal_other) {
      formData.append(
        "non_maya_preferred_terminal_other",
        partialDetails.non_maya_preferred_terminal_other
      );
    }
    if (
      partialDetails.non_maya_choose_preferred_reasons &&
      partialDetails.non_maya_choose_preferred_reasons.length > 0
    ) {
      formData.append(
        "non_maya_choose_preferred_reasons",
        partialDetails.non_maya_choose_preferred_reasons.join(", ")
      );
    }
    if (partialDetails.non_maya_choose_preferred_other) {
      formData.append(
        "non_maya_choose_preferred_other",
        partialDetails.non_maya_choose_preferred_other
      );
    }
    if (
      partialDetails.non_maya_not_accept_maya_reasons &&
      partialDetails.non_maya_not_accept_maya_reasons.length > 0
    ) {
      formData.append(
        "non_maya_not_accept_maya_reasons",
        partialDetails.non_maya_not_accept_maya_reasons.join(", ")
      );
    }
    if (partialDetails.non_maya_not_accept_maya_other) {
      formData.append(
        "non_maya_not_accept_maya_other",
        partialDetails.non_maya_not_accept_maya_other
      );
    }

     // From VisibilityPhoto.jsx
    if (partialDetails.feedback) {
      formData.append("feedback", partialDetails.feedback);
    }
    if (partialDetails.revisit_detail) {
      formData.append("revisit_detail", partialDetails.revisit_detail);
    }
    
    // From Remarks.jsx
    if (partialDetails.remarks) {
      formData.append("remarks", partialDetails.remarks);
    }
    if (partialDetails.visit_duration) {
      formData.append("visit_duration", partialDetails.visit_duration);
    }

   // -- PROMOTIONAL ACTIVITY --

   //PromotionalActivity.jsx
   if (partialDetails.promotional_activity) {
      formData.append("promotional_activity", partialDetails.promotional_activity);
    }

   //  From MayaMallProgramSection70.jsx
    if (partialDetails.joined_maya_program) {
      formData.append("joined_maya_program", partialDetails.joined_maya_program);
    }
    if (partialDetails.not_joined_maya_program_reason) {
      formData.append("not_joined_maya_program_reason", partialDetails.not_joined_maya_program_reason);
    }
//. CIP ROLLOUT
    // From JoiningMayaMallProgramSection72.jsx
    if (partialDetails.program_participation) {
      formData.append("program_participation", partialDetails.program_participation);
    }
    if (partialDetails.preferred_incentive) {
      formData.append("preferred_incentive", partialDetails.preferred_incentive);
    }
    if (partialDetails.mobile_number) {
      formData.append("mobile_number", partialDetails.mobile_number);
    }
    if (partialDetails.total_terminals_joined) {
      formData.append("total_terminals_joined", partialDetails.total_terminals_joined);
    }
    if (partialDetails.mid_terminals_joined) {
      formData.append("mid_terminals_joined", partialDetails.mid_terminals_joined);
    }
    if (partialDetails.total_sqr_joined) {
      formData.append("total_sqr_joined", partialDetails.total_sqr_joined);
    }
    if (partialDetails.store_code_sqr) {
      formData.append("store_code_sqr", partialDetails.store_code_sqr);
    }
    if (partialDetails.poc_name) {
      formData.append("poc_name", partialDetails.poc_name);
    }
    if (partialDetails.poc_position) {
      formData.append("poc_position", partialDetails.poc_position);
    }
    if (partialDetails.date_signed) {
      formData.append("date_signed", partialDetails.date_signed);
    }
    if (partialDetails.reason_not_joined_mall_champion) {
      formData.append("reason_not_joined_mall_champion", partialDetails.reason_not_joined_mall_champion);
    }
    if (partialDetails.joined_maya_kita_club) {
      formData.append("joined_maya_kita_club", partialDetails.joined_maya_kita_club);
    }
    if (partialDetails.facebook_accnt_name) {
      formData.append("facebook_accnt_name", partialDetails.facebook_accnt_name);
    }
    if (partialDetails.reason_not_joined_maya_kita_club) {
      formData.append("reason_not_joined_maya_kita_club", partialDetails.reason_not_joined_maya_kita_club);
    }


    // From CompetitorPriority.jsx
     if (partialDetails.which_acquirer) {
      formData.append("which_acquirer", partialDetails.which_acquirer);
    }
     if (partialDetails.on_going_promo) {
      formData.append("on_going_promo", partialDetails.on_going_promo);
    }
     if (partialDetails.promo_title) {
      formData.append("promo_title", partialDetails.promo_title);
    }
     if (partialDetails.promo_mechanics) {
      formData.append("promo_mechanics", partialDetails.promo_mechanics);
    }
     if (partialDetails.duration) {
      formData.append("duration", partialDetails.duration);
    }
// INCENTIVE VERIFICATION
     // From MayaAccountDetails.jsx
    if (partialDetails.is_incentive_confirmed) {
      formData.append("is_incentive_confirmed", partialDetails.is_incentive_confirmed);
    }
    if (partialDetails.maya_account_holder_name) {
      formData.append("maya_account_holder_name", partialDetails.maya_account_holder_name);
    }
    if (partialDetails.maya_account_number) {
      formData.append("maya_account_number", partialDetails.maya_account_number);
    }

// AWARDING MERIENDA
    // From AwardingMerienda.jsx
    if (partialDetails.amount) {
      formData.append("amount", partialDetails.amount);
    }
    if (partialDetails.food_item) {
      formData.append("food_item", partialDetails.food_item);
    }
    if (partialDetails.or_no) {
      formData.append("or_no", partialDetails.or_no);
    }
    if (partialDetails.receiver_name) {
      formData.append("receiver_name", partialDetails.receiver_name);
    }
    if (partialDetails.receiver_position) {
      formData.append("receiver_position", partialDetails.receiver_position);
    }
    // From AwardingFeedback.jsx
    if (partialDetails.is_merienda_satisfied) {
      formData.append("is_merienda_satisfied", partialDetails.is_merienda_satisfied);
    }
    if (partialDetails.merienda_feedback) {
      formData.append("merienda_feedback", partialDetails.merienda_feedback);
    }
    if (partialDetails.merienda_option_prize) {
      formData.append("merienda_option_prize", partialDetails.merienda_option_prize);
    }

// AWARDING MAYA CREDIT
    // From AwardingMayaCredit.jsx
    if (partialDetails.received_maya_credits) {
      formData.append("received_maya_credits", partialDetails.received_maya_credits);
    }
    if (partialDetails.change_incentive) {
      formData.append("change_incentive", partialDetails.change_incentive);
    }
    if (partialDetails.maya_account_name) {
      formData.append("maya_account_name", partialDetails.maya_account_name);
    }
    if (partialDetails.maya_account_number) {
      formData.append("maya_account_number", partialDetails.maya_account_number);
    }
    // From AwardingDetails.jsx
    if (partialDetails.is_credit_satisfied) {
      formData.append("is_credit_satisfied", partialDetails.is_credit_satisfied);
    }
    if (partialDetails.maya_credit_feedback) {
      formData.append("maya_credit_feedback", partialDetails.maya_credit_feedback);
    }
    if (partialDetails.credit_option_prize) {
      formData.append("credit_option_prize", partialDetails.credit_option_prize);
    }

// AWARDING FLAGSHIP
    // From AwardingFlagship.jsx
    if (partialDetails.total_eco_bag) {
      formData.append("total_eco_bag", partialDetails.total_eco_bag);
    }
    if (partialDetails.total_ballpen) {
      formData.append("total_ballpen", partialDetails.total_ballpen);
    }
    if (partialDetails.total_notebook) {
      formData.append("total_notebook", partialDetails.total_notebook);
    }
    if (partialDetails.total_fan) {
      formData.append("total_fan", partialDetails.total_fan);
    }
    if (partialDetails.total_calculator) {
      formData.append("total_calculator", partialDetails.total_calculator);
    }
    if (partialDetails.total_mug) {
      formData.append("total_mug", partialDetails.total_mug);
    }
    if (partialDetails.flagship_receiver_name) {
      formData.append("flagship_receiver_name", partialDetails.flagship_receiver_name);
    }
    if (partialDetails.flagship_receiver_position) {
      formData.append("flagship_receiver_position", partialDetails.flagship_receiver_position);
    }

// FLAGSHIP FEEDBACK
    // From FlagshipFeedback.jsx
    if (partialDetails.is_flagship_satisfied) {
      formData.append("is_flagship_satisfied", partialDetails.is_flagship_satisfied);
    }
    if (partialDetails.flagship_feedback) {
      formData.append("flagship_feedback", partialDetails.flagship_feedback);
    }
    if (partialDetails.flagship_option_prize) {
      formData.append("flagship_option_prize", partialDetails.flagship_option_prize);
    }

    // if (partialDetails.monthly_sale_reason) {
    //   formData.append("monthly_sale_reason", partialDetails.monthly_sale_reason);
    // }
  
    // if (partialDetails.poa) {
    //   formData.append("poa", partialDetails.poa);
    // }
    // if (partialDetails.terminal_model) {
    //   const models = Array.isArray(partialDetails.terminal_model)
    //     ? JSON.stringify(partialDetails.terminal_model)
    //     : partialDetails.terminal_model;
    //   formData.append("terminal_model", models);
    // }
    // if (partialDetails.serial_number) {
    //   formData.append("serial_number", partialDetails.serial_number);
    // }
    // if (partialDetails.terminal_id) {
    //   formData.append("terminal_id", partialDetails.terminal_id);
    // }
    // if (partialDetails.card_efs) {
    //   formData.append("card_efs", partialDetails.card_efs);
    // }
    // if (partialDetails.merchant_id) {
    //   formData.append("merchant_id", partialDetails.merchant_id);
    // }
    // if (partialDetails.reason_no_mid) {
    //   const reasons = Array.isArray(partialDetails.reason_no_mid)
    //     ? JSON.stringify(partialDetails.reason_no_mid)
    //     : partialDetails.reason_no_mid;
    //   formData.append("reason_no_mid", reasons);
    // }
    // if (partialDetails.other_reason_no_mid) {
    //   formData.append("other_reason_no_mid", partialDetails.other_reason_no_mid);
    // }
    // if (partialDetails.is_defective) {
    //   formData.append("is_defective", partialDetails.is_defective);
    // }

    // // From DefectiveTerminalDetails.jsx
    // if (partialDetails.defective_count) {
    //   formData.append("defective_count", partialDetails.defective_count);
    // }
    // if (partialDetails.defective_id) {
    //   formData.append("defective_id", partialDetails.defective_id);
    // }
    // if (partialDetails.defective_serial_nos) {
    //   formData.append("defective_serial_nos", partialDetails.defective_serial_nos);
    // }
    // if (partialDetails.escalation_case_no) {
    //   formData.append("escalation_case_no", partialDetails.escalation_case_no);
    // }

    

//     // From TerminalStickering.jsx
    if (partialDetails.no_stickered_reason) {
      formData.append("no_stickered_reason", partialDetails.no_stickered_reason);
    }
    if (partialDetails.num_stickered_detail) {
      formData.append("num_stickered_detail", partialDetails.num_stickered_detail);
    }

// // na end dri
//     // From ThermalRoll.jsx
    if (partialDetails.thermal_roll_stock) {
      formData.append("thermal_roll_stock", partialDetails.thermal_roll_stock);
    }
    if (partialDetails.thermal_roll_delivery) {
      formData.append("thermal_roll_delivery", partialDetails.thermal_roll_delivery);
    }

//     // From P1StandeeMerchandisingPage.jsx
//     if (partialDetails.standee_visible) {
//       formData.append("standee_visible", partialDetails.standee_visible);
//     }

//     // From P1StandeeDetails.jsx
//     if (partialDetails.standee_location) {
//       formData.append("standee_location", partialDetails.standee_location);
//     }
//     if (partialDetails.standee_brand) {
//       formData.append("standee_brand", partialDetails.standee_brand);
//     }
//     if (partialDetails.standee_count) {
//       formData.append("standee_count", partialDetails.standee_count);
//     }

//     // From NotVisibleP1Standee.jsx
//     if (partialDetails.standee_unvisible_reason) {
//       formData.append("standee_unvisible_reason", partialDetails.standee_unvisible_reason);
//     }
//     if (partialDetails.other_reason_p1_not_visible) {
//       formData.append("other_reason_p1_not_visible", partialDetails.other_reason_p1_not_visible);
//     }

//     // From P1DoorHangerMerchandisingPage.jsx
//     if (partialDetails.door_hanger_visible) {
//       formData.append("door_hanger_visible", partialDetails.door_hanger_visible);
//     }

//     // From P1DoorHangerDetailsPage.jsx
//     if (partialDetails.door_hanger_location) {
//       formData.append("door_hanger_location", partialDetails.door_hanger_location);
//     }
//     if (partialDetails.door_hanger_brand) {
//       formData.append("door_hanger_brand", partialDetails.door_hanger_brand);
//     }
//     if (partialDetails.door_hanger_count) {
//       formData.append("door_hanger_count", partialDetails.door_hanger_count);
//     }
//     // not sure p1_door_hanger_details_description
//     // if (partialDetails.p1_door_hanger_details_description) {
//     //   formData.append("p1_door_hanger_details_description", partialDetails.p1_door_hanger_details_description);
//     // }

//     // From NotVisibleP1DoorHangerPage.jsx
//     if (partialDetails.door_hanger_unvisible_reason) {
//       formData.append("door_hanger_unvisible_reason", partialDetails.door_hanger_unvisible_reason);
//     }
//     //wla sa database
//     if (partialDetails.other_reason_p1_door_hanger_not_visible) {
//       formData.append("other_reason_p1_door_hanger_not_visible", partialDetails.other_reason_p1_door_hanger_not_visible);
//     }
//     //not sure
//     // if (partialDetails.not_visible_p1_door_hanger_description) {
//     //   formData.append("not_visible_p1_door_hanger_description", partialDetails.not_visible_p1_door_hanger_description);
//     // }


//     // From P1DoorStickerMerchandisingPage.jsx
//     if (partialDetails.door_sticker_visible) {
//       formData.append("door_sticker_visible", partialDetails.door_sticker_visible);
//     }

//     // From P1DoorStickerDetails.jsx (visible path)
//     if (partialDetails.door_sticker_location) {
//       formData.append("door_sticker_location", partialDetails.door_sticker_location);
//     }

//     // From NotVisibleP1DoorStickerPage.jsx (not visible path)
//     if (partialDetails.door_sticker_uninstalled_reason) {
//       formData.append("door_sticker_uninstalled_reason", partialDetails.door_sticker_uninstalled_reason);
//     }
//     // wla na dapat ini
//     // if (partialDetails.other_reason_p1_door_sticker_not_visible) {
//     //   formData.append("other_reason_p1_door_sticker_not_visible", partialDetails.other_reason_p1_door_sticker_not_visible);
//     // }
//     // if (partialDetails.not_visible_p1_door_sticker_description) {
//     //   formData.append("not_visible_p1_door_sticker_description", partialDetails.not_visible_p1_door_sticker_description);
//     // }

//     // From InstallP1TerminalMerch.jsx (decision flags)
//     if (partialDetails.standee_installed) formData.append("standee_installed", partialDetails.standee_installed);
//     if (partialDetails.door_hanger_installed) formData.append("door_hanger_installed", partialDetails.door_hanger_installed);
//     if (partialDetails.qr_troubleshooting_sticker_installed) formData.append("qr_troubleshooting_sticker_installed", partialDetails.qr_troubleshooting_sticker_installed);
//     if (partialDetails.door_sticker_installed) formData.append("door_sticker_installed", partialDetails.door_sticker_installed);

//     // From InstalledP1DoorSticker.jsx
//     if (partialDetails.door_sticker_installed_location) {
//       formData.append("door_sticker_installed_location", partialDetails.door_sticker_installed_location);
//     }
//     if (partialDetails.door_sticker_installed_photo) {
//       formData.append("door_sticker_installed_photo", partialDetails.door_sticker_installed_photo);
//     }

//     // --- Maya SQR & QRPH Modules ---
//     // From MayaSQRSolution.jsx
//     if (partialDetails.sqr_solution) {
//       formData.append("sqr_solution", partialDetails.sqr_solution);
//     }

//     // From UpdatedSQR.jsx
//     // if (partialDetails.sqr_updated) {
//     //   formData.append("sqr_updated", partialDetails.sqr_updated);
//     // }

//     // // From SQRBrandingVersion.jsx
//     // if (partialDetails.sqr_brand) {
//     //   formData.append("sqr_brand", partialDetails.sqr_brand);
//     // }
//     // if (partialDetails.sqr_unupdated_reason) {
//     //   formData.append("sqr_unupdated_reason", partialDetails.sqr_unupdated_reason);
//     // }

//     // // From SQRPhoto.jsx — skipping explicit file key append as component doesn't bind to shared state
//     // if (partialDetails.sqr_photo) {
//     //   formData.append("sqr_photo", partialDetails.sqr_photo);
//     // }

//     // From QRPHDoorHangerMerch.jsx
//     if (partialDetails.qrph_door_hanger_visible) {
//       formData.append("qrph_door_hanger_visible", partialDetails.qrph_door_hanger_visible);
//     }
//     // From QRPHDoorHangerDetails.jsx
//     if (partialDetails.qrph_door_hanger_location) {
//       formData.append("qrph_door_hanger_location", partialDetails.qrph_door_hanger_location);
//     }
//     if (partialDetails.qrph_door_hanger_brand) {
//       formData.append("qrph_door_hanger_brand", partialDetails.qrph_door_hanger_brand);
//     }
//     if (partialDetails.qrph_door_hanger_count) {
//       formData.append("qrph_door_hanger_count", partialDetails.qrph_door_hanger_count);
//     }

//     if (partialDetails.qrph_door_hanger_unvisible_reason) {
//       formData.append("qrph_door_hanger_unvisible_reason", partialDetails.qrph_door_hanger_unvisible_reason);
//     }

//     // From QRPHDoorStickerMerch.jsx
//     if (partialDetails.qrph_door_sticker_visible) {
//       formData.append("qrph_door_sticker_visible", partialDetails.qrph_door_sticker_visible);
//     }

//     // From QRPHDoorStickerDetails.jsx
//     if (partialDetails.qrph_door_sticker_location) {
//       formData.append("qrph_door_sticker_location", partialDetails.qrph_door_sticker_location);
//     }
// // NotVisibleQRPHDoorSticker
//     if (partialDetails.qrph_door_sticker_unvisible_reason) {
//       formData.append("qrph_door_sticker_unvisible_reason", partialDetails.qrph_door_sticker_unvisible_reason);
//     }

//     // From InstallSQRMerch.jsx
//     if (partialDetails.qrph_door_hanger_installed) {
//       formData.append("qrph_door_hanger_installed", partialDetails.qrph_door_hanger_installed);
//     }
//     if (partialDetails.qrph_troubleshooting_sticker_installed) {
//       formData.append("qrph_troubleshooting_sticker_installed", partialDetails.qrph_troubleshooting_sticker_installed);
//     }
//     if (partialDetails.qrph_door_sticker_installed) {
//       formData.append("qrph_door_sticker_installed", partialDetails.qrph_door_sticker_installed);
//     }

//     // From InstalledQRPHDoorSticker.jsx
//     if (partialDetails.qrph_door_sticker_installed_location) {
//       formData.append("qrph_door_sticker_installed_location", partialDetails.qrph_door_sticker_installed_location);
//     }
//     if (partialDetails.qrph_door_sticker_installed_photo) {
//       formData.append("qrph_door_sticker_installed_photo", partialDetails.qrph_door_sticker_installed_photo);
//     }

//     // From NotInstalledQRPHDoorSticker.jsx
//     if (partialDetails.qrph_door_sticker_uninstalled_reason) {
//       formData.append("qrph_door_sticker_uninstalled_reason", partialDetails.qrph_door_sticker_uninstalled_reason);
//     }
//     // if (partialDetails.other_reason_p1_door_sticker_not_visible) {
//     //   formData.append("other_reason_p1_door_sticker_not_visible", partialDetails.other_reason_p1_door_sticker_not_visible);
//     // }

//     // From MayaMallProgramCIP.jsx
//     if (partialDetails.cip_task) {
//       formData.append("cip_task", partialDetails.cip_task);
//     }
//     if (partialDetails.cip_status) {
//       formData.append("cip_status", partialDetails.cip_status);
//     }

    if (partialDetails.other_not_joining_reason) {
      formData.append("other_not_joining_reason", partialDetails.other_not_joining_reason);
    }


//     // From MayaAccount.jsx
//     if (partialDetails.verified_account) {
//       formData.append("verified_account", partialDetails.verified_account);
//     }



//     // From MayaKitaClub.jsx
//     if (partialDetails.facebook_account_name) {
//       formData.append("facebook_account_name", partialDetails.facebook_account_name);
//     }
//     if (partialDetails.facebook_club) {
//       formData.append("facebook_club", partialDetails.facebook_club);
//     }

    

//     // From TerminalConcerns.jsx
//     if (partialDetails.simCard) {
//       const v = Array.isArray(partialDetails.simCard)
//         ? JSON.stringify(partialDetails.simCard)
//         : partialDetails.simCard;
//       formData.append("simCard", v);
//     }
//     if (partialDetails.simCard_other_details) {
//       formData.append("simCard_other_details", partialDetails.simCard_other_details);
//     }
//     if (partialDetails.charger) {
//       const v = Array.isArray(partialDetails.charger)
//         ? JSON.stringify(partialDetails.charger)
//         : partialDetails.charger;
//       formData.append("charger", v);
//     }
//     if (partialDetails.charger_other_details) {
//       formData.append("charger_other_details", partialDetails.charger_other_details);
//     }
//     if (partialDetails.battery) {
//       const v = Array.isArray(partialDetails.battery)
//         ? JSON.stringify(partialDetails.battery)
//         : partialDetails.battery;
//       formData.append("battery", v);
//     }
//     if (partialDetails.battery_other_details) {
//       formData.append("battery_other_details", partialDetails.battery_other_details);
//     }
//     if (partialDetails.lcd) {
//       const v = Array.isArray(partialDetails.lcd)
//         ? JSON.stringify(partialDetails.lcd)
//         : partialDetails.lcd;
//       formData.append("lcd", v);
//     }
//     if (partialDetails.lcd_other_details) {
//       formData.append("lcd_other_details", partialDetails.lcd_other_details);
//     }
//     if (partialDetails.terminal) {
//       const v = Array.isArray(partialDetails.terminal)
//         ? JSON.stringify(partialDetails.terminal)
//         : partialDetails.terminal;
//       formData.append("terminal", v);
//     }
//     if (partialDetails.terminal_other_details) {
//       formData.append("terminal_other_details", partialDetails.terminal_other_details);
//     }
//     if (partialDetails.cradle) {
//       const v = Array.isArray(partialDetails.cradle)
//         ? JSON.stringify(partialDetails.cradle)
//         : partialDetails.cradle;
//       formData.append("cradle", v);
//     }
//     if (partialDetails.cradle_other_details) {
//       formData.append("cradle_other_details", partialDetails.cradle_other_details);
//     }
//     if (partialDetails.software) {
//       const v = Array.isArray(partialDetails.software)
//         ? JSON.stringify(partialDetails.software)
//         : partialDetails.software;
//       formData.append("software", v);
//     }
//     if (partialDetails.software_other_details) {
//       formData.append("software_other_details", partialDetails.software_other_details);
//     }
//     if (partialDetails.sqr) {
//       const v = Array.isArray(partialDetails.sqr)
//         ? JSON.stringify(partialDetails.sqr)
//         : partialDetails.sqr;
//       formData.append("sqr", v);
//     }
//     if (partialDetails.sqr_other_details) {
//       formData.append("sqr_other_details", partialDetails.sqr_other_details);
//     }


//     // From ZeroToLowMerchant.jsx
//     // if (partialDetails.merchant_transaction) {
//     //   formData.append("merchant_transaction", partialDetails.merchant_transaction);
//     // }

//     // From ZeroToLowMerchantYes.jsx
//     if (partialDetails.maya_transaction) {
//       formData.append("maya_transaction", partialDetails.maya_transaction);
//     }
//     // if (partialDetails.zero_to_low_details) {
//     //   formData.append("zero_to_low_details", partialDetails.zero_to_low_details);
//     // }


//     // From DCCFlyer.jsx
//     if (partialDetails.dcc_installed) {
//       formData.append("dcc_installed", partialDetails.dcc_installed);
//     }

//     // From DCCFlyerPhoto.jsx
//     if (partialDetails.dcc_photo) {
//       formData.append("dcc_photo", partialDetails.dcc_photo);
//     }

//     // From MayaKitaClubFlyer.jsx
//     if (partialDetails.flyer_distribution) {
//       formData.append("flyer_distribution", partialDetails.flyer_distribution);
//     }

//     // From RevisitDetails.jsx
//     // if (partialDetails.revisit_detail) {
//     //   formData.append("revisit_detail", partialDetails.revisit_detail);
//     // }

//     // From MayaKitaClubFlyerPhoto.jsx
//     if (partialDetails.flyer_distribution_photo) {
//       formData.append("flyer_distribution_photo", partialDetails.flyer_distribution_photo);
//     }

//     // From TroubleshootQRSticker.jsx
//     if (partialDetails.qr_sticker_distribution) {
//       formData.append("qr_sticker_distribution", partialDetails.qr_sticker_distribution);
//     }
    
//     // From TroubleshootQRStickerPhoto.jsx
//     if (partialDetails.qr_sticker_distribution_photo) {
//       formData.append("qr_sticker_distribution_photo", partialDetails.qr_sticker_distribution_photo);
//     } 

//     // From TroubleShootP1Sticker.jsx
//     if (partialDetails.p1_sticker_distribution) {
//       formData.append("p1_sticker_distribution", partialDetails.p1_sticker_distribution);
//     }

//     // From TroubleshootP1StickerPhoto.jsx
//     if (partialDetails.p1_sticker_distribution_photo) {
//       formData.append("p1_sticker_distribution_photo", partialDetails.p1_sticker_distribution_photo);
//     }

    

    // Decide endpoint based on presence of an existing ID
      const updateResponse = await postAPICall2(
      process.env.REACT_APP_LINK + "forms/add",
      formData
    );
    
    return { data: updateResponse.data };
      
  } catch (error) {
    return { error: error?.response };
  }
};

//Add Customer API
export const createCustomer = async (
  id,
  details,
  productCodes,
  freebies,
  promoList
) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken().replace(/['"]+/g, ""))
    formData.append("form_id", id)

    for (const [key, value] of Object.entries(details)) {
      formData.append(key, value)
    }

    productCodes.map((data) => {
      formData.append("purchased_products[]", data.qty)
    })

    promoList.map((data) => {
      formData.append("promotions[]", data.name)
      formData.append("promotion_qties[]", data.qty)
    })

    freebies.map((data) => {
      formData.append("freebies[]", data.name)
      formData.append("freebie_qties[]", data.qty)
    })

    const response = await postAPICall2(
      process.env.REACT_APP_LINK + "forms/add_customer",
      formData
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

//Get Store API
export const getLocations = async (
  date_from,
  date_to,
  latitude,
  longitude,
  page
) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "forms/search",
      {
        requester: getUser(),
        token: getToken().replace(/['"]+/g, ""),
        date_from: date_from,
        date_to: date_to,
        encoded_by: `${getFirstName()} ${getLastName()}`,
        role: getUserType(),
        latitude: latitude,
        longitude: longitude,
        page: page,
      }
    )
    return { data: response.data.data }
  } catch (error) {
    return { error: error.response }
  }
}
export const getAccounts = async () => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "accounts/get",
      {
        requester: getUser(),
        token: getToken().replace(/['"]+/g, ""),
      }
    )
    return { data: response.data.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getPromos = async (activation_type, classification_type) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "promos/get",
      {
        requester: getUser(),
        token: getToken().replace(/['"]+/g, ""),
        classification_type: classification_type,
        activation_type: activation_type,
      }
    )
    return { data: response.data.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getFreebies = async () => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "freebies/get",
      {
        requester: getUser(),
        token: getToken().replace(/['"]+/g, ""),
      }
    )
    return { data: response.data.data }
  } catch (error) {
    return { error: error.response }
  }
}

// GOOGLE API
export const getLocationOnLoad = async (lat, lng) => {
  try {
    const response = await getAPICallGoogle(
      "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
        lat +
        "," +
        lng +
        "&key=AIzaSyAHeix3Mf1YRppXp1hxArkPwkevOZFc1Ew"
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getDropdownData = async () => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "forms/get_form_dropdown_data",
      {
        requester: getUser(),
        token: getToken().replace(/['"]+/g, ""),
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getAllMerchants = async () => {
  // Use mock response if enabled
  if (USE_MOCK_AUTH) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            data: [
              { id: 1, name: "Sample Merchant 1", value: 1, label: "Sample Merchant 1" },
              { id: 2, name: "Sample Merchant 2", value: 2, label: "Sample Merchant 2" },
              { id: 3, name: "Sample Merchant 3", value: 3, label: "Sample Merchant 3" },
            ]
          }
        });
      }, 500);
    });
  }

  // Original API call for production
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "merchants/get_all",
      {
        requester: getUser(),
        token: getToken().replace(/['"]+/g, ""),
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getMerchant = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "merchants/get",
      {
        requester: getUser(),
        token: getToken().replace(/['"]+/g, ""),
        merchant_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getAllOutlets = async () => {
  // Use mock response if enabled
  if (USE_MOCK_AUTH) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            data: [
              { id: 1, name: "Main Branch", value: 1, label: "Main Branch" },
              { id: 2, name: "Branch 2", value: 2, label: "Branch 2" },
              { id: 3, name: "Branch 3", value: 3, label: "Branch 3" },
            ]
          }
        });
      }, 500);
    });
  }

  // Original API call for production
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "outlets/get_all",
      {
        requester: getUser(),
        token: getToken().replace(/['"]+/g, ""),
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

//Get All Users API
export const get_all_user = async () => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "forms/get_all_user",
      {
        requester: getUser(),
        token: getToken().replace(/['"]+/g, ""),
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// Extract text from image using OCR
export const extractImageText = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await postAPICall2(
      process.env.REACT_APP_LINK + "images/extract",
      formData
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
}

